import { Box, Button, Typography, styled } from '@mui/material';
import { SOFT_BORDER_DARK, SOFT_BORDER_LIGHT } from 'src/helpers/uiTokens';
import { AI_CREDIT_INK } from '../types';

/* The AI-credit accent. A literal because the violet ramp belongs to the
 * AI Credits mark, not to the app's primary colour. */
const VIOLET = '#5B34C7';

/** Bordered container holding the pack summary and the quantity stepper. */
export const PackCard = styled(Box)(({ theme }) => ({
  border: `1px solid ${SOFT_BORDER_LIGHT}`,
  borderRadius: '14px',
  overflow: 'hidden',
  ...theme.applyStyles('dark', { borderColor: SOFT_BORDER_DARK }),
}));

/** Separates the pack summary from the quantity stepper. */

/** Separates the pack summary from the quantity stepper. */
export const PackStepperRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '11px 16px',
  borderTop: `1px solid ${SOFT_BORDER_LIGHT}`,
  ...theme.applyStyles('dark', { borderTopColor: SOFT_BORDER_DARK }),
}));

export const PackHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '14px 16px',
  background: 'linear-gradient(120deg, #f5f1ff, #fbfaff)',
  ...theme.applyStyles('dark', {
    background: 'linear-gradient(120deg, #241a4a, #1b1630)',
  }),
}));

export const PackTitle = styled(Typography)(({ theme }) => ({
  fontSize: 15,
  fontWeight: 800,
  color: AI_CREDIT_INK,
  ...theme.applyStyles('dark', { color: '#c9b8ff' }),
}));

export const StepperGroup = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  border: `1px solid ${SOFT_BORDER_LIGHT}`,
  borderRadius: '999px',
  padding: '3px',
  backgroundColor: '#fbfcfe',
  ...theme.applyStyles('dark', {
    borderColor: SOFT_BORDER_DARK,
    backgroundColor: theme.palette.action.hover,
  }),
}));

export const StepButton = styled(Button)(({ theme }) => ({
  minWidth: 30,
  width: 30,
  height: 30,
  padding: 0,
  borderRadius: '99px',
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.background.paper,
  boxShadow: '0 1px 3px rgba(15,41,66,.12)',
  '&:hover': { backgroundColor: theme.palette.background.paper },
  '&.Mui-disabled': { opacity: 0.4 },
}));

export const SummaryRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

/** Hairline above the "Your Credits balance" line. */

/** Hairline above the "Your Credits balance" line. */
export const SummaryDivider = styled(Box)(({ theme }) => ({
  height: '1px',
  margin: '2px 0',
  backgroundColor: SOFT_BORDER_LIGHT,
  ...theme.applyStyles('dark', { backgroundColor: SOFT_BORDER_DARK }),
}));

/** Shown when the Credits balance can't cover the order. */

/** Shown when the Credits balance can't cover the order. */
export const ShortfallPanel = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '9px',
  alignItems: 'flex-start',
  padding: '11px 13px',
  borderRadius: '12px',
  backgroundColor: '#fdf1f3',
  border: '1px solid #f6d6dc',
  ...theme.applyStyles('dark', {
    backgroundColor: '#2e1418',
    borderColor: '#552831',
  }),
}));

export const BuyButton = styled(Button)(({ theme }) => ({
  width: '100%',
  padding: '14px 16px',
  borderRadius: '12px',
  textTransform: 'none',
  fontSize: 14,
  fontWeight: 700,
  color: '#fff',
  backgroundColor: VIOLET,
  boxShadow: '0 10px 22px -12px rgba(91,52,199,.9)',
  '&:hover': { backgroundColor: AI_CREDIT_INK },
  '&.Mui-disabled': {
    backgroundColor: '#e9edf2',
    color: '#a6b2bf',
    boxShadow: 'none',
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.text.disabled,
    }),
  },
}));
